import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=eaa9a224&"
import script from "./EmailDetails.vue?vue&type=script&lang=js&"
export * from "./EmailDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports